import * as types from '../types';
import AppReducers from './AppReducers';

const reducer = (state, action) => AppReducers(action.type !== types.LOGOUT ? state : undefined, action);

export default reducer;
